import { render, staticRenderFns } from "./CommentariesWindow.vue?vue&type=template&id=185e6a09&scoped=true&"
import script from "./CommentariesWindow.vue?vue&type=script&lang=js&"
export * from "./CommentariesWindow.vue?vue&type=script&lang=js&"
import style0 from "./CommentariesWindow.vue?vue&type=style&index=0&id=185e6a09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185e6a09",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VBtnToggle,VCol,VRow,VTextarea})
